import React, {Component} from 'react';
import converter from 'number-to-words';
import NumberFormat from 'react-number-format';
import $ from 'jquery';
import {Title} from '../../../../model/Helper';
import moment from 'moment';
import {blank_line} from '../../../../model/Const';

class Preview extends Component {

	constructor(props) {
        super(props);
        this.state = {
            focus: ".paper-title"
        }
    }

    isVisible(el) {
		var elementTop = $(el).offset().top;
		var elementBottom = elementTop + $(el).outerHeight();
	
		var viewportTop = $(window).scrollTop();
		var viewportBottom = viewportTop + $(window).height();
	
		return elementBottom > viewportTop && elementTop < viewportBottom;
	}

	componentWillReceiveProps(newProps) {
		let ff = newProps.formFocus?newProps.formFocus:'paper-title';

        this.setState({
            focus: '.'+ff
        }, ()=>{
            //console.log(this.state.focus)
            let screenPos = $(window).height()/3;
            let el = $(this.state.focus).length?$(this.state.focus):$(".paper-title");
            let scrollVal = el.get(0).offsetTop-screenPos || 0;
            
            $(".paper").animate({
                scrollTop: scrollVal
            }, 100);
            
        });
	}

	componentDidMount() {

		$(window).scroll(()=>{

			// This setup will be enabled only with at least md window width
			if($(window).width()>767){
				// Header setup
				// Make preview stay at the top and fixed display when header is not visible
				if(this.isVisible(".header")){
					//console.log("Visible");
					$(".right-preview .preview").css({
						"position": "relative",
						"top": "auto",
						"padding-right": "0"
					});
				} else {
					//console.log("Not visible");
					$(".right-preview .preview").css({
						"position": "fixed",
						"top": "1rem",
						"padding-right": "15px"
					});
				}

			}
		});
	}

    render() {
        // Data
        // Data
		let c = this.props.details.corporation;
		let p = this.props.details.property;

		let blankLine = blank_line;

		let title = (Title(p)) ? Title(p) : blankLine;

		let cName = (c.name) ? c.name : blankLine;
		let cAddress = (c.address) ? c.address : blankLine;

		let representativeMname = (c.representativeMname) ? " "+c.representativeMname : "";
		let representativeLname = (c.representativeLname) ? " "+c.representativeLname : "";
		let representativeSuffix = (c.representativeSuffix) ? " "+c.representativeSuffix : "";
		let cRepresentativePosition = (c.representativePosition) ? c.representativePosition : blankLine;
		let cRepresentativeName = (c.representativeFname || c.represemtativeMname || c.representativeLname) ? 
								(c.representativeFname+representativeMname+representativeLname+representativeSuffix): 
								blankLine;
		
		// Set date and date format
		let cBoardMeeting = blankLine;
		if(c.meetingDate) {
			cBoardMeeting = moment(c.meetingDate).format('LL');
		}

		let pAddress = (p.address) ? p.address : blankLine;
		let areaNumber = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
							<NumberFormat value={parseFloat(p.area)} displayType="text" thousandSeparator={true} /> :
							blankLine;
		let areaText = (typeof parseFloat(p.area) === "number" && parseFloat(p.area)>0) ?
							converter.toWords(p.area) : 
							blankLine;
		let priceNumber = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
							<NumberFormat value={parseFloat(p.price)} displayType="text" thousandSeparator={true} /> :
							blankLine;		
		let priceText = (typeof parseFloat(p.price) === "number" && parseFloat(p.price)>0) ?
							converter.toWords(p.price) : 
							blankLine;

        return (
            <div className="preview">
				<div className="default-preview-fade top"></div>
				<div className="top-preview">
					<div className="text-center">
						<p>Preview</p>
					</div>

					<div className="paper">
					<div className="paper-inner">

                        <div className="paper-title-no-underline text-center mt-0">
                            {cName}
                        </div>

                        <div className="paper-title text-center">
							Board Resolution
						</div>

                        <div>
                            <p>
                                We, the undersigned members of the Board of Directors of <span className="font-weight-bold dynamic-data text-uppercase corporation_name">{cName}</span>, a domestic corporation duly organized and existing under and by virtue of the laws of the Republic of the Philippines, with principal office at <span className="dynamic-data text-capitalize corporation_address">{cAddress}</span>, do hereby resolve, as follows:
                            </p>
                        </div>

                        <div className="paper-narrow">
                            <p>
                                “RESOLVED, that the <span className="dynamic-data text-capitalize corporation_representativePosition">{cRepresentativePosition}</span>, <span className="font-weight-bold dynamic-data text-uppercase corporation_representativeFname corporation_representativeMname corporation_representativeLname corporation_representativeSuffix">{cRepresentativeName}</span>, be authorized to act for and in behalf of the Corporation to SELL, TRANSFER and CONVEY to any interested person or entity who is willing, ready and able to buy, under such terms and conditions it may deem favorable, a real property owned and registered under the name of the Corporation, covered by <span className="dynamic-data text-capitalize property_ctn property_tct property_oct property_type property_registrationType">{title}</span> (hereinafter “Subject Real Property”), located at <span className="dynamic-data text-capitalize property_address">{pAddress}</span>, with an area of <span className="dynamic-data property_area text-uppercase">{areaText} ({areaNumber})</span> square meters, amounting to <span className="dynamic-data property_price text-uppercase">{priceText} PESOS (P{priceNumber})</span> Philippine Currency;
                            </p>
                        </div>

                        <div className="paper-narrow">
                            <p>
                                RESOLVED, FURTHER, that the <span className="dynamic-data text-capitalize">{cRepresentativePosition}</span>, in furtherance of and for the implementation of the power and authority granted, be allowed to sign, make, and execute such documents as may be necessary to carry into effect the sale of the Subject Real Property, and to accept and collect full payment, in the name of the corporation, the proceeds of the sale and sign for the receipt thereof; and
                            </p>
                        </div>

                        <div className="paper-narrow">
                            <p>        
                                RESOLVED, FINALLY, that the <span className="dynamic-data text-capitalize">{cRepresentativePosition}</span> is authorized to do and perform any and all other lawful acts and deeds necessary to undertake the execution and finalization of the sale, transfer, or conveyance of the Subject Real Property.”
                            </p>
                        </div>

                        <div>
                            <p>Approved and adopted on <span className="dynamic-data corporation_meetingDate">{cBoardMeeting}</span>.</p>
                        </div>

                        <div className="w-100 mt-5 row corporation_tempbod">
							{
								//console.log("let go:", c.bod);
								c.bod.map((obj, i)=>{
									return (
										<div key={i} className="col-6">
											<div className="text-center my-3">
												<span className="dynamic-data font-weight-bold text-uppercase">{obj}</span><br />Director
											</div>
										</div>
									)
								})
							}
                        </div>

                    </div>
					</div> {/* end of paper */}

                </div>
                <div className="default-preview-fade"></div>
            </div>
        )
    }
}

export default Preview;


// WEBPACK FOOTER //
// ./src/pages/contracts/free-contracts/board-resolution-to-sell/Preview.js